module.exports = __webpack_public_path__ + "static/media/fa-brands-400.a06da7f0.woff2";